// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610082116/js/" + chunkId + "." + {"44":"3d6cd672","225":"7517adb7","481":"4ee00586","486":"64652456","770":"bb096a45"}[chunkId] + ".0.07824968769748997.chunk.js";
};